import React, { useState } from "react";
import {
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Form,
  FormGroup,
} from "reactstrap";
import "./monitoringQueueTableDropdown.css";
import { CustomCheckBoxTableHeader } from "../../../../../../../components/common/CusomMUIComponents";
import { useSelector } from "react-redux";
import {
  selectTableCheckboxChecked,
  selectTableHeaderDropdownValue,
} from "../../../../../selectors";
import { TABLE_HEADER_DROPDOWN_VALUES } from "../../../../../constants/monitoringQueueEntryConstants";

const MonitoringQueueTableDropdown = ({
  checkBoxChangeSelection,
  dropdownitemchange,
}) => {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const checked = useSelector(selectTableCheckboxChecked);
  const currentTableHeader = useSelector(selectTableHeaderDropdownValue);
  const toggle = () => setDropdownOpen((prevState) => !prevState);

  return (
    <Form>
      <FormGroup check inline>
        <CustomCheckBoxTableHeader
          name="mq-entry"
          onChange={checkBoxChangeSelection}
          checked={checked}
        />
        <Dropdown isOpen={dropdownOpen} toggle={toggle} direction="down">
          <DropdownToggle tag="span" caret />
          <DropdownMenu style={{padding:"0px !important"}} id="checkboxdropdown">
            <DropdownItem
              active={
                currentTableHeader === TABLE_HEADER_DROPDOWN_VALUES.ON_THIS_PAGE
              }
              onClick={(a) => dropdownitemchange(a)}
              value={TABLE_HEADER_DROPDOWN_VALUES.ON_THIS_PAGE}
            >
              All on this page
            </DropdownItem>
            <DropdownItem
              active={currentTableHeader === TABLE_HEADER_DROPDOWN_VALUES.ALL}
              onClick={(a) => dropdownitemchange(a)}
              value={TABLE_HEADER_DROPDOWN_VALUES.ALL}
            >
              All
            </DropdownItem>
            <DropdownItem
              active={currentTableHeader === TABLE_HEADER_DROPDOWN_VALUES.NONE}
              onClick={(a) => dropdownitemchange(a)}
              value={TABLE_HEADER_DROPDOWN_VALUES.NONE}
            >
              None
            </DropdownItem>
          </DropdownMenu>
        </Dropdown>
      </FormGroup>
    </Form>
  );
};
export default MonitoringQueueTableDropdown;



// WEBPACK FOOTER //
// ./src/features/monitoring-queue-entry/components/searching/search-form/table/dropdown/MonitoringQueueTableDropdown.jsx